<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p11"><span><a href="#/Contents#rp11">EASY FISH STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Any kind of mild-flavored fish will make a delicious stock; avoid strongly flavored fish such as salmon or tuna. Stock will keep in refrigerator for 2 days, or up to 2 months in the freezer.</i></span></p>
<p class="make"><span>Makes about 1 quart</span></p>
<p class="hang"><span>3½ cups water</span></p>
<p class="hang"><span>¾ cup dry white wine or water</span></p>
<p class="hang"><span>1½ pounds fresh or frozen fish steaks, cubed (1-inch)</span></p>
<p class="hang"><span>1 each: finely chopped medium onion, carrot</span></p>
<p class="hang"><span>3 ribs celery with leaves, halved</span></p>
<p class="hang"><span>3 sprigs parsley</span></p>
<p class="hang"><span>3 slices lemon</span></p>
<p class="hang"><span>8 black peppercorns</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><a id="page_9"></a><b>1.</b> Heat all ingredients to boiling in large saucepan; reduce heat and simmer 30 minutes, skimming any foam from surface. Strain stock through double layer of cheesecloth, discarding fish, vegetables, and seasoning; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 10</span></p>
<p class="per1"><span>% calories from fat: 3</span></p>
<p class="per1"><span>Protein (g): 0.7</span></p>
<p class="per1"><span>Carbohydrate (g): 0.2</span></p>
<p class="per1"><span>Fat (g): 0</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 2</span></p>
<p class="per1"><span>Sodium (mg): 3</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0111.vue?afe9f76a